import AOS from 'aos';
import initializeMobileMenu from './menu';
import initializeForms from './forms';
import initializeSearch from './search';
import initializeMainSlider from './blocks/slider';
import initializeObituarySlider from './blocks/obituary-slider';
import initializeOfficesSearch from './blocks/offices-search';
import initializeShopsSearch from './blocks/shops-search';
import initializeObituary from './blocks/obituary';
import initializeFancybox from './fancybox';
import initializeComments from './comments';

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        AOS.init({
            disable: 'mobile',
            once: true,
            duration: 1000
        });
        initializeMobileMenu();
        initializeForms();
        initializeMainSlider();
        initializeObituarySlider();
        initializeOfficesSearch();
        initializeShopsSearch();
        initializeFancybox();
        initializeObituary();
        initializeSearch();
        initializeComments();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
